module.exports = __webpack_public_path__ + "img/vogue-1.48c12920.png";